<template>
  <ionic-vue-page
    v-bind:title="screenTitle"
    v-bind:showBackButton="false"
    v-bind:refresh="refresh"
  >
    <shifts-calendar></shifts-calendar>

    <error-message v-if="error" v-bind:message="error"></error-message>

    <skeleton-list v-if="currentMonthBreakdown.length === 0"></skeleton-list>

    <monthly-pay-breakdown
      v-else
      v-for="(breakdown, index) in currentMonthBreakdown"
      :key="index"
      :breakdown="breakdown"
      :products="products"
    ></monthly-pay-breakdown>

    <div class="ion-text-center" style="margin-bottom: 36px;">
      <ion-button href="/earnings" shape="round" fill="outline"
        >View All Earnings</ion-button
      >
    </div>

    <offers-slider v-bind:offers="offers"></offers-slider>
  </ionic-vue-page>
</template>

<script>
import ShiftsCalendar from "./../components/ShiftsCalendar";
import OffersSlider from "./../components/OffersSlider";
import MonthlyPayBreakdown from "./../components/MonthlyPayBreakdown";
import SkeletonList from "./../components/SkeletonList";
import paymentsApiService from "./../services/PaymentsApi";
import productsApiService from "./../services/ProductsApi";
import offersApiService from "./../services/OffersApi";
import shiftsApiService from "./../services/ShiftsApi";
import mixins from "./../mixins/mixins";
import moment from "moment";
import ErrorMessage from "./../components/ErrorMessage";
import { Deploy } from "cordova-plugin-ionic";

export default {
  name: "Dashboard",
  mixins: [mixins],
  components: {
    "shifts-calendar": ShiftsCalendar,
    "offers-slider": OffersSlider,
    "monthly-pay-breakdown": MonthlyPayBreakdown,
    "skeleton-list": SkeletonList,
    "error-message": ErrorMessage,
  },
  computed: {
    webOnly() {
      return process.env.VUE_APP_WEB_ONLY == "true";
    },
  },
  data() {
    return {
      screenTitle: "Dashboard",
      currentMonthBreakdown: [],
      products: [],
      offers: [],
      camHours: {},
      error: false,
    };
  },
  async mounted() {
    const loading = await this.$ionic.loadingController.create({
      message: "Loading dashboard...",
    });
    loading.present();

    if (!this.webOnly) {
      //check for updates
      const update = await Deploy.checkForUpdate();

      if (update.available) {
        await loading.dismiss();

        return this.$router.push("updating");
      }
    }

    try {
      const screenData = await this.getData();

      this.products = screenData[0];
      this.currentMonthBreakdown = this.handlePaymentsData(screenData[1]);
      this.offers = screenData[2];
      this.camHours = screenData[3];
    } catch (error) {
      this.error = error;
      throw error;
    } finally {
      loading.dismiss();
    }
  },
  methods: {
    async refresh(event) {
      this.products = [];
      this.currentMonthBreakdown = [];
      this.offers = [];
      this.camHours = {};

      try {
        const screenData = await this.getData();

        this.products = screenData[0];
        this.currentMonthBreakdown = this.handlePaymentsData(screenData[1]);
        this.offers = screenData[2];
        this.camHours = screenData[3];
      } catch (error) {
        this.error = error;
      } finally {
        event.target.complete();
      }
    },

    async getData() {
      const paramDateFormat = "YYYY-MM-DD";

      const startDate = moment()
        .startOf("month")
        .format(paramDateFormat);
      const endDate = moment()
        .endOf("month")
        .format(paramDateFormat);

      const productsCall = productsApiService.get();
      const paymentsCall = paymentsApiService.getMonthly(startDate, endDate);
      const offersCall = offersApiService.get();
      const camHoursCall = shiftsApiService.getThisMonthsHours();

      return await Promise.all([
        productsCall,
        paymentsCall,
        offersCall,
        camHoursCall,
      ]);
    },
  },
};
</script>
